module.exports = __webpack_public_path__ + "static/img/copyright3.1cbdd7ff.png";